// VFX: CTA Triple Action Cards
// Slug: ui_cta-triple-cards_cascade_1000ms
// Category: card-animations
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;
type CTACard = { icon: string; label: string; sublabel?: string; color?: string };
type Props = { cards?: CTACard[]; staggerFrames?: number; dark?: boolean };

const DEFAULT_CARDS: CTACard[] = [
  { icon: "❤", label: "Curtir", sublabel: "se fez sentido", color: "#ef4444" },
  { icon: "@", label: "Seguir", sublabel: "@guilhermeribeiro.ai", color: "#6366f1" },
  { icon: "💬", label: "Comentar", sublabel: "sua maior dúvida", color: "#34d399" },
];

export default function UiCtaTripleCardsCascade1000ms({
  cards = DEFAULT_CARDS,
  staggerFrames = 14,
  dark = true,
}: Props) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const bg = dark ? "#060608" : "#fafafa";
  const cardBg = dark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)";
  const textColor = dark ? "#f0f0f0" : "#1a1a2e";
  const mutedColor = dark ? "#666" : "#999";
  return (
    <AbsoluteFill
      style={{
        background: bg,
        justifyContent: "center",
        alignItems: "center",
        padding: "0 40px",
        flexDirection: "column",
        gap: 14,
      }}
    >
      {cards.map((card, i) => {
        const delay = i * staggerFrames;
        const p = spring({ frame: frame - delay, fps, config: { damping: 130, stiffness: 180 } });
        if (frame < delay) return null;
        const color = card.color || "#6366f1";
        return (
          <div
            key={i}
            style={{
              width: 580,
              opacity: p,
              transform: `translateY(${interpolate(p, [0, 1], [30, 0], clamp)}px) scale(${interpolate(
                p,
                [0, 1],
                [0.92, 1],
                clamp
              )})`,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 20,
                padding: "18px 24px",
                borderRadius: 16,
                background: cardBg,
                border: `1px solid ${color}22`,
                boxShadow: `0 2px 8px rgba(0,0,0,0.3), 0 0 0 1px ${color}11`,
              }}
            >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  flexShrink: 0,
                  background: `${color}18`,
                  border: `1px solid ${color}33`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                }}
              >
                {card.icon}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 18, fontWeight: 600, color: textColor, fontFamily: "system-ui" }}>
                  {card.label}
                </div>
                {card.sublabel && (
                  <div style={{ fontSize: 13, color: mutedColor, fontFamily: "system-ui", marginTop: 2 }}>
                    {card.sublabel}
                  </div>
                )}
              </div>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color,
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  fontFamily: "system-ui",
                }}
              >
                →
              </div>
            </div>
          </div>
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
